import Grid from '@mui/material/Grid';
import Title from "../Shared/Title";
import Match from "../Match/Match";

const Row = props => {
    return (
        <Grid container className="ContainerRow">
            <Grid item xs={4}>
                <Title
                    row
                    href={`/queries/${props.item.Id}`}
                    icons={props.icons}
                    label={props.item.Name}
                />
            </Grid>
            <Grid item xs={8}>
                <Grid container sx={{ border: '0px solid' }}>
                    <Grid item xs={6}>
                        <Match type="schemas" matches={props.matches.schemas} />
                    </Grid>
                    <Grid item xs={6}>
                        <Match type="jobs" matches={props.matches.jobs} />
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    )
}

export default Row